<template>
  <div :id="`${id}_cont`" class="form-check" v-if="showContent">
    <input :id="id" class="form-check-input" type="checkbox" :name="name"
      @change="$emit('update:modelValue', $event.target.checked)" :checked="modelValue" />
    <label :for="id" class="custom-control-label title">
      <slot />{{ text }}
    </label>
  </div>
  <!-- Loading -->
  <div :id="`${id}_cont`" class="form-check" v-else>
    <input :id="id" class="form-check-input" type="checkbox" />
    <label class="title placeholder-glow col-12 mb-0 pb-0">
      <span class="placeholder col-12"></span>
    </label>
  </div>
</template>

<script>
export default {
  name: "VsudCheckbox",
  props: {
    name: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    id: {
      type: String,
      default: ""
    },
    checked: {
      type: String,
      default: ""
    },
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showContent: false,
      minLoadTime: 1500,
      loadStart: null,
    };
  },
  mounted() {
    this.loadStart = Date.now();
    window.addEventListener("load", this.onLoad);
    setTimeout(() => {
      this.showContent = true;
    }, this.minLoadTime);
  },
  beforeUnmount() {
    window.removeEventListener("load", this.onLoad);
  },
  methods: {
    onLoad() {
      const loadTime = Date.now() - this.loadStart;
      if (loadTime >= this.minLoadTime) {
        this.showContent = true;
      } else {
        setTimeout(() => {
          this.showContent = true;
        }, this.minLoadTime - loadTime);
      }
    },
  },
};
</script>

<style scoped>
.title {
  color: var(--black);
  font-size: 0.9rem;
  font-weight: 500;
}
.placeholder{
  min-width: 100px;
  width: 100%;
}
</style>